module.exports = __webpack_public_path__ + "media/images/flags/1x1/cpv-6d0b75f029d6c4b4bef3916e91b7e92a.svg";